<template>
  <sc-page-base
    :title="title"
    :loading="loading">
    <div class="box">
      <div class="columns">
        <div class="column is-4">
          <article class="panel is-primary">
            <p class="panel-heading has-text-primary has-text-weight-bold">
              Fatura: {{ invoiceDetail.invoice_number }}
            </p>

            <div class="panel-block page-invoice-detail__panel__block">
              <div class="columns page-invoice-detail__cols">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">Data de Geração:</h6>
                </div>
                <div class="column has-text-right">
                  <p>{{ invoiceDetail.generation_date | date('DD/MM/YYYY') }}</p>
                </div>
              </div>
            </div>

            <div class="panel-block page-invoice-detail__panel__block">
              <div class="columns page-invoice-detail__cols">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">Data de vencimento:</h6>
                </div>
                <div class="column has-text-right">
                  <p>{{ invoiceDetail.expiration_date | date('DD/MM/YYYY') }}</p>
                </div>
              </div>
            </div>

            <div class="panel-block page-invoice-detail__panel__block">
              <div class="columns page-invoice-detail__cols">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">Transportadora:</h6>
                </div>
                <div class="column has-text-right">
                  <p>{{ invoiceDetail.logistic_provider }}</p>
                </div>
              </div>
            </div>

            <div class="panel-block page-invoice-detail__panel__block">
              <div class="columns page-invoice-detail__cols">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">Notas Fiscais:</h6>
                </div>
                <div class="column has-text-right">
                  <p>{{ invoiceDetail.total_nf_document }}</p>
                </div>
              </div>
            </div>

            <div class="panel-block page-invoice-detail__panel__block">
              <div class="columns page-invoice-detail__cols">
                <div class="column is-narrow">
                  <h6 class="has-text-weight-bold">Valor Total:</h6>
                </div>
                <div class="column has-text-right">
                  <p>{{ invoiceDetail.total_value | currency }}</p>
                </div>
              </div>
            </div>
          </article>
        </div>

      </div>
    </div>

    <div class="box">
      <sc-table
        :data="invoiceDetail.invoice_infos"
        default-sort="invoice"
        :per-page='pagination.limit'
        paginated>
        <template slot-scope="{ row }">

          <sc-table-column
            field="nf_document"
            label="Nota Fiscal"
            sortable>
            {{ row.nf_document }}
          </sc-table-column>

          <sc-table-column
            field="nf_document_serie"
            label="Série NF"
            sortable>
            {{ row.nf_document_serie }}
          </sc-table-column>

          <sc-table-column
            field="nf_document_value"
            label="Valor NF">
            {{ row.nf_document_value | currency }}
          </sc-table-column>

          <sc-table-column
            field="document_number"
            label="Série Docto">
            {{ row.document_number }}
          </sc-table-column>

          <sc-table-column
            field="document"
            label="Número do Docto">
            {{ row.document }}
          </sc-table-column>   

          <sc-table-column
            field="freight_value"
            label="Valor do Frete">
            {{ row.freight_value | currency }}
          </sc-table-column>

          <sc-table-column
            field="taxe_value_icms"
            label="ICMS">
            {{ row.taxe_value_icms | currency }}
          </sc-table-column>

        </template>

        <template slot="bottom-left">
          <sc-table-per-page v-model="pagination.limit" />
        </template>

        <template slot="empty">
          <sc-table-empty />
        </template>
      </sc-table>

      <div class="columns page-invoice-detail__footer">
        <div class="column">
          <div class="buttons is-right">
            <sc-button 
              class="is-primary"
              @click="exportExcel"
              :loading="loadingExports"
            >
              <span>Exportar para o Excel</span>
              <sc-icon
                icon="file-excel"
                size="is-small" />
            </sc-button>
          </div>
        </div>
      </div>
    </div>
  </sc-page-base>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScButton,
  ScIcon,
  ScPageBase,
  ScToast,
  ScTable,
  ScTableColumn,
  ScTableEmpty,
  ScTablePerPage,
} from '@intelipost-js/secure-components';

const {
  mapState,
  mapActions,
} = createNamespacedHelpers('recon/invoiceDetail');

export default {
  name: 'page-invoice-detail',
  data() {
    return {
      title: 'Detalhe da Fatura',
      pagination: {
        page: 1,
        limit: 10,
      },
    };
  },
  computed: {
    ...mapState([
      'loading',
      'loadingExports',
      'invoiceDetail',
    ]),
  },
  methods: {
    ...mapActions([
      'getInvoiceDetail',
      'exportToExcel',
    ]),
    exportExcel() {
      const params = this.$route.params.id;
      return this.exportToExcel({ id: params }).then(() =>
        ScToast.success('O relatório está sendo gerado, assim que finalizado estará disponível na seção Meus Arquivos.'),
      );
    },
  },
  mounted() {
    const params = this.$route.params.id;
    this.getInvoiceDetail({ id: params });
  },
  components: {
    ScButton,
    ScIcon,
    ScPageBase,
    ScToast,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScTablePerPage,
  },
};
</script>

<style lang="scss" scoped>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-invoice-detail {
  &__panel {
    &__block {
      &:first-child {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }

      &:last-child {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }

  &__cols {
    flex: 1;

    .column {
      word-break: break-all;
    }
  }

  &__footer{
    background-color: $white-ter;
    border-top: 1px solid #e7e7e7;
    padding: 1.25rem;
    border-radius: 0 0 5px 5px;
    margin: 1.25rem -1.25rem -1.25rem -1.25rem;
    padding: 0.5rem;
  }
}
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/invoice-detail/PageInvoiceDetail.vue